// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Hold all third party libraries override
*/

/*
OpenLayers
*/
.ol-scale-line-inner {
  display: none;
}

/*
yet-another-react-lightbox
*/
.yarl__button {
  width: 44px !important;
  height: 44px !important;
  padding: 0px !important;
}

.yarl__button > svg {
  width: 24px !important;
  height: 24px !important;
}

.yarl__navigation_prev > svg, .yarl__navigation_next > svg {
  width: 36px !important;
  height: 36px !important;
}

.yarl__button:focus {
  background-color: white !important;
  color: #000 !important;
  border-radius: 50% !important;
}`, "",{"version":3,"sources":["webpack://./src/ui/style/vendor.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;;CAEC;AACD;EACE,aAAa;AACf;;AAEA;;CAEC;AACD;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,6BAA6B;AAC/B","sourcesContent":["/*\r\nHold all third party libraries override\r\n*/\r\n\r\n/*\r\nOpenLayers\r\n*/\r\n.ol-scale-line-inner {\r\n  display: none;\r\n}\r\n\r\n/*\r\nyet-another-react-lightbox\r\n*/\r\n.yarl__button {\r\n  width: 44px !important;\r\n  height: 44px !important;\r\n  padding: 0px !important;\r\n}\r\n\r\n.yarl__button > svg {\r\n  width: 24px !important;\r\n  height: 24px !important;\r\n}\r\n\r\n.yarl__navigation_prev > svg, .yarl__navigation_next > svg {\r\n  width: 36px !important;\r\n  height: 36px !important;\r\n}\r\n\r\n.yarl__button:focus {\r\n  background-color: white !important;\r\n  color: #000 !important;\r\n  border-radius: 50% !important;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
